/*!
 * ua.fields.type.select
 * Multi-select control for registered field types.
 */

var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.fields.type.select",
  title: "Field Type Select",
  description: "Select one or more field types from the registered field catalog.",
  control: true,
  preview: "ua.preview.text",
  supportServer: false,
  fields: {
    name: {
      title: "Name",
      type: "string",
      description: "Form field name.",
      required: true
    },
    title: {
      title: "Title",
      type: "string",
      description: "Control title.",
      required: true
    },
    description: {
      title: "Description",
      type: "inner",
      description: "Helper description."
    },
    required: {
      title: "Required",
      type: "boolean",
      description: "Whether at least one type must be selected."
    },
    types: {
      title: "Types",
      type: "list",
      of: "object",
      description: "Field type catalog entries."
    },
    value: {
      title: "Value",
      type: "any",
      description: "Selected type (string) or types (list)."
    }
  }
});

function normalizeTypes(types) {
  if (!(types instanceof Array)) return [];

  var out = [];
  for (var i = 0; i < types.length; i++) {
    var row = types[i] || {};
    var ns = (row.namespace || row.type || "").toString().trim();
    if (!ns) continue;

    out.push({
      namespace: ns,
      title: (row.title || ns).toString(),
      description: (row.description || "").toString(),
      showInEditor: row.showInEditor !== false
    });
  }
  return out;
}

function splitTypesByHidden(types) {
  var visible = [];
  var hidden = [];

  for (var i = 0; i < types.length; i++) {
    var item = types[i];
    if (item && item.showInEditor === false) {
      hidden.push(item);
    } else {
      visible.push(item);
    }
  }

  return {
    visible: visible,
    hidden: hidden
  };
}

function createTypeOption(row, selected) {
  var option = document.createElement("label");
  option.className = "ua-field-type-select-option";

  var input = document.createElement("input");
  input.type = "checkbox";
  input.setAttribute("data-field-type-option", "true");
  input.value = row.namespace;
  input.checked = selected.indexOf(row.namespace) >= 0;

  var card = document.createElement("div");
  card.className = "ua-field-type-select-card";

  var ns = document.createElement("div");
  ns.className = "ua-field-type-select-namespace";
  ns.textContent = row.namespace;
  card.appendChild(ns);

  var t = document.createElement("div");
  t.className = "ua-field-type-select-title";
  t.textContent = row.title || row.namespace;
  card.appendChild(t);

  var d = document.createElement("p");
  d.className = "ua-field-type-select-description";
  d.textContent = row.description || "";
  card.appendChild(d);

  option.appendChild(input);
  option.appendChild(card);
  return option;
}

function normalizeSelected(value) {
  if (value instanceof Array) {
    return value.map(function(item) {
      return (item || "").toString().trim();
    }).filter(function(item) {
      return !!item;
    });
  }

  var text = (value || "").toString().trim();
  if (!text) return [];
  return [text];
}

exports.render = async function(options) {
  var name = (options.name || "").toString();
  var title = (options.title || "").toString();
  var description = (options.description || "").toString();
  var required = options.required === true;
  var types = normalizeTypes(options.types || []);
  var groupedTypes = splitTypesByHidden(types);
  var selected = normalizeSelected(options.value);

  var wrapper = document.createElement("div");
  wrapper.className = "form-group pb-3 ua-field-type-select";
  wrapper.setAttribute("name", name);
  if (required) wrapper.setAttribute("data-required", "true");

  var label = document.createElement("label");
  label.className = "pb-2 fs-4";
  label.textContent = title;
  wrapper.appendChild(label);

  if (description) {
    var help = document.createElement("div");
    help.className = "form-text mb-2";
    help.textContent = description;
    wrapper.appendChild(help);
  }

  if (groupedTypes.hidden.length > 0) {
    var tools = document.createElement("div");
    tools.className = "ua-field-type-select-tools";

    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "btn btn-outline-secondary btn-sm ua-field-type-select-toggle";
    toggle.setAttribute("data-toggle-hidden", "false");
    toggle.textContent = "Show Hidden (" + groupedTypes.hidden.length + ")";
    tools.appendChild(toggle);
    wrapper.appendChild(tools);
  }

  var grid = document.createElement("div");
  grid.className = "ua-field-type-select-grid";
  wrapper.appendChild(grid);

  function renderGrid(showHidden) {
    var checked = grid.querySelectorAll("input[data-field-type-option='true']:checked");
    for (var c = 0; c < checked.length; c++) {
      var value = (checked[c].value || "").toString().trim();
      if (!value) continue;
      if (selected.indexOf(value) >= 0) continue;
      selected.push(value);
    }

    grid.innerHTML = "";

    for (var i = 0; i < groupedTypes.visible.length; i++) {
      grid.appendChild(createTypeOption(groupedTypes.visible[i], selected));
    }

    if (showHidden) {
      for (var j = 0; j < groupedTypes.hidden.length; j++) {
        grid.appendChild(createTypeOption(groupedTypes.hidden[j], selected));
      }
    }
  }

  renderGrid(false);

  grid.addEventListener("change", function(event) {
    var target = event.target;
    if (!target || target.getAttribute("data-field-type-option") !== "true") return;
    var value = (target.value || "").toString().trim();
    if (!value) return;

    if (target.checked) {
      if (selected.indexOf(value) < 0) selected.push(value);
    } else {
      selected = selected.filter(function(item) {
        return item !== value;
      });
    }
  });

  var hiddenToggle = wrapper.querySelector("[data-toggle-hidden]");
  if (hiddenToggle) {
    hiddenToggle.addEventListener("click", function() {
      var current = hiddenToggle.getAttribute("data-toggle-hidden") === "true";
      var next = !current;
      hiddenToggle.setAttribute("data-toggle-hidden", next ? "true" : "false");
      hiddenToggle.textContent = next ? "Hide Hidden" : ("Show Hidden (" + groupedTypes.hidden.length + ")");
      renderGrid(next);
    });
  }

  return wrapper;
};

async function save(name, control, repo) {
  var required = control.getAttribute("data-required") === "true";
  var checks = control.querySelectorAll("input[data-field-type-option='true']:checked");
  var selected = [];

  for (var i = 0; i < checks.length; i++) {
    var value = (checks[i].value || "").toString().trim();
    if (!value) continue;
    if (selected.indexOf(value) >= 0) continue;
    selected.push(value);
  }

  repo.errors = [];
  if (required && selected.length === 0) {
    repo.success = false;
    repo.errors.push({
      type: "validation",
      message: "At least one field type is required."
    });
    control.classList.add("is-invalid");
    repo.data = "";
    return repo;
  }

  control.classList.remove("is-invalid");
  repo.success = true;

  if (selected.length <= 1) {
    repo.data = selected[0] || "";
  } else {
    repo.data = selected;
  }

  return repo;
}
module.exports.save = save;

async function load(name, control, data) {
  var selected = normalizeSelected(data);
  var checks = control.querySelectorAll("input[data-field-type-option='true']");

  for (var i = 0; i < checks.length; i++) {
    checks[i].checked = selected.indexOf(checks[i].value) >= 0;
  }
}
module.exports.load = load;
